import { BRAND } from "@/lib/content";

export const OnlineFooter = () => (
  <footer className="border-t border-surfaceline bg-ink px-4 py-12 sm:px-8" data-testid="online-footer">
    <div className="mx-auto max-w-6xl">
      <div className="max-w-xl">
        <div className="flex items-center gap-2.5">
          <img
            src={BRAND.logo}
            alt="BullsEdge Academy"
            className="h-10 w-10 rounded-lg object-contain ring-1 ring-surfaceline"
          />
          <div className="leading-none">
            <span className="block font-display text-xl font-bold text-offwhite">
              BullsEdge Academy
            </span>
            <span className="text-[0.62rem] font-semibold uppercase tracking-[0.18em] text-gold">
              Online Live Classes
            </span>
          </div>
        </div>
        <p className="mt-4 text-sm leading-relaxed text-mutedgreen">
          Live sessions across India · WhatsApp: {BRAND.phoneDisplay}
        </p>
      </div>

      <div className="my-8 gold-divider" />

      <div className="rounded-2xl border border-surfaceline bg-surface p-5">
        <p className="text-xs leading-relaxed text-mutedgreen">
          <span className="font-semibold text-offwhite">Disclaimer:</span>{" "}
          BullsEdge Academy provides stock market and trading education through
          live online classes. We are not a SEBI-registered advisor, and we do not
          offer stock tips, buy/sell recommendations, or promise any returns.
          Strategy performance shown is based on backtested/historical data and is
          not a guarantee of future results. Stock market and trading involves
          risk of loss.
        </p>
      </div>

      <p className="mt-8 text-center text-xs text-mutedgreen/60">
        © {new Date().getFullYear()} BullsEdge Academy. All rights reserved.
      </p>
    </div>
  </footer>
);
